module.exports = __webpack_public_path__ + "img/check.065db348.svg";